import { css } from '@emotion/css';

import { UNSPLASH_RANDOM_URL } from '@/hooks/useUnsplash/useUnsplash';

export const randomCardStyles = css`
  background-size: contain;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url(${UNSPLASH_RANDOM_URL}) center center/cover;
`;

export const imageContainerStyles = css`
  height: 10.6rem;
`;

export const containerStyles = css`
  border: 2px solid transparent;
`;
export const selectedContainerStyles = css`
  border: 2px solid var(--focus-primary);
  border-radius: 1.2rem;
`;
